import Handler from "../Handler";

class RoomIDUpdateHandler extends Handler {
    // roomIdUpdate#
    // {
    //     "gameDefId" : "123",
    //     "roomId" : "123",
    //     "isTableListingEnabled" : true,
    //     "tableListingChannel" : [channel1,channel2]
    // }
    execute(data) {
        let receivedData = JSON.parse(data);
        console.log("roomIdUpdate received data:", receivedData);
        this.service.processRoomIDUpdateData(receivedData);
    }
}

export default RoomIDUpdateHandler;